module.exports = __webpack_public_path__ + "static/media/main_img3.10c2fea4.svg";